import React, { Component } from "react";
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import { bindActionCreators } from "redux";
import Image from "../../../../../../components/ZUILib/Image";
// import ImageLink from '../../../../../../components/ZUILib/ImageLink';
import InputButton from "../../../../../../components/ZUILib/InputButton";
import Link from "../../../../../../components/ZUILib/Link";
import * as giftListActions from "../../actions";
import serverClientUtil from "../../../../../../utils/serverClientUtil";
import commonUtil from "../../../../../../utils/commonUtil";
import * as defaultConst from "../../../../../../utils/clientConstant";
import Tagging from "../../../../../../components/Tagging";

const predefinedStatus = [
  defaultConst.eventStatus.SUSPENDED_FOR_TIME,
  defaultConst.eventStatus.SUSPENDED,
  defaultConst.eventStatus.VALIDITY_OFF_ACTIVE,
  defaultConst.eventStatus.TEMPORARY_CLOSED,
  defaultConst.eventStatus.CLOSED,
];

const applicationRoutes = commonUtil.getApplicationRoutes();

const { getEventSummaryInfo } = giftListActions;

class GiftListHeader extends Component {
  predeterminedRoute = "";
  isDisabled = false;
  eventSummaryInfo = {};
  eventStatusInfo = "";

  renderHeaderData = () => {
    const eventSummaryResponse = this.props.eventSummaryInfoHeader;
    const eventStatus =
      eventSummaryResponse && eventSummaryResponse.eventInfo
        ? eventSummaryResponse.eventInfo.eventStatus
        : undefined;

    if (
      eventSummaryResponse.status &&
      eventSummaryResponse.status === "success"
    ) {
      this.eventSummaryInfo = eventSummaryResponse;

      if (
        document &&
        typeof document !== "undefined" &&
        this.props.compareEventStatus(eventStatus, predefinedStatus)
      ) {
        this.isDisabled = true;
      }
      if (
        this.props.compareEventStatus(
          eventStatus,
          defaultConst.eventStatus.SUSPENDED_FOR_TIME
        )
      ) {
        this.isDisabled = true;
      }
      if (eventSummaryResponse.eventInfo.predeterminedListIdExists === false) {
        this.predeterminedRoute = "";
      }
      if (eventSummaryResponse.eventInfo.predeterminedListIdExists === true) {
        this.predeterminedRoute = commonUtil.getRouteByParameter(
          applicationRoutes.predeterminedLists,
          {
            eventType: eventSummaryResponse.eventInfo
              ? eventSummaryResponse.eventInfo.eventType.replace("/", "%2F")
              : "",
            eventID: this.props.eventId,
          }
        );
      }
      if (
        this.props.compareEventStatus(
          eventStatus,
          defaultConst.eventStatus.SUSPENDED_FOR_TIME
        ) ||
        this.props.compareEventStatus(
          eventStatus,
          defaultConst.eventStatus.DELETED
        )
      ) {
        browserHistory.push(
          commonUtil.getRouteByParameter("/eventoEstadoSuspendidoPorTiempo")
        );
      }
      if (this.props.handleSuspendedEventUpdate) {
        this.props.handleSuspendedEventUpdate(eventSummaryResponse);
      }
      this.eventStatusInfo = eventStatus;
    }
  };

  showAgregarDropdown = () => {
    if (document && typeof document !== "undefined") {
      const agregarDropdown = document.getElementById("dropdown");
      if (agregarDropdown.className === "dropdown") {
        document.querySelector("#dropdown").classList.add("open");
      } else {
        agregarDropdown.classList.remove("open");
      }
    }
  };

  accountStatusRoute = () => {
    browserHistory.push(
      commonUtil.getRouteByParameter(applicationRoutes.accountStatus, {
        eventID: this.props.eventId,
      })
    );
  };

  componentDidMount = () => {
    const self = this;
    const agregarLink = document.querySelector("#dLabel");
    const agregarDropdown = document.getElementById("dropdown");
    window.addEventListener("click", () => {
      const dataLayer = {};
      dataLayer.event = "Mesa de Regalos";
      dataLayer.eventCategory = "Mesa de Regalos";
      dataLayer.eventAction = "Agregar regalo a mi Mesa";
      if (agregarLink && agregarLink.contains(event.target)) {
        dataLayer.eventAction = "click";
        dataLayer.eventLabel = event.target.textContent;
        this.tagging.applyGTM("Mesa de Regalos", dataLayer);
        return false;
      } else if (
        agregarDropdown &&
        this.showAgregarDropdown &&
        agregarDropdown.className === "dropdown open"
      ) {
        dataLayer.eventLabel = event.target.textContent;
        this.tagging.applyGTM("Mesa de Regalos", dataLayer);
        self.showAgregarDropdown();
      }
      return false;
    });
  };

  catalogoHandler = () => {
    // eslint-disable-next-line no-undef
    dataLayer.push({
      event: "evTypeMesaAdd",
      selectOption: "Catalogo_Liverpool",
    });
  };

  predefinedHandler = () => {
    // eslint-disable-next-line no-undef
    dataLayer.push({
      event: "evTypeMesaAdd",
      selectOption: "Listas_predeterminadas",
    });
  };

  suggestionHandler = () => {
    // eslint-disable-next-line no-undef
    dataLayer.push({
      event: "evTypeMesaAdd",
      selectOption: "Lista_de_sugerencias",
    });
  };

  componentWillUnmount() {
    window.removeEventListener("click", () => {});
  }
  render() {
    const lables = this.props.lables;
    const _url = serverClientUtil.getLPFullURL() + "/home";
    let eventIconImageURL =
      commonUtil.getAssetURL() + "/images/gifts/gift_bodas.svg";
    const linkJSON = [];
    if (this.props.eventSummaryInfoHeader) {
      this.renderHeaderData();
    } else {
      return null;
    }
    const eventType =
      this.props.eventSummaryInfoHeader &&
      this.props.eventSummaryInfoHeader.eventInfo
        ? this.props.eventSummaryInfoHeader.eventInfo.eventType
        : undefined;

    switch (eventType) {
      case defaultConst.eventType.Boda:
      case defaultConst.eventType.Aniversario:
        eventIconImageURL =
          commonUtil.getAssetURL() + "/images/gifts/gift_bodas.svg";
        break;
      case defaultConst.eventType.Baptism:
      case defaultConst.eventType.Bebe:
        eventIconImageURL =
          commonUtil.getAssetURL() + "/images/gifts/gift_bebes.svg";
        break;
      case defaultConst.eventType.XV_Anos:
        eventIconImageURL =
          commonUtil.getAssetURL() + "/images/gifts/gift_quince.svg";
        break;
      case defaultConst.eventType.Bar_Mitzvah:
      case defaultConst.eventType.Bat_Mitzvah:
      case defaultConst.eventType.First_Communion:
      case defaultConst.eventType.Confirmacion:
      case defaultConst.eventType.Despedida:
      case defaultConst.eventType.Open_House:
      case defaultConst.eventType.Other_Religious_Ceremonies:
      case defaultConst.eventType.Others:
        eventIconImageURL =
          commonUtil.getAssetURL() + "/images/gifts/gift_ceremonias.svg";
        break;
      case defaultConst.eventType.Mascotas:
        eventIconImageURL =
          commonUtil.getAssetURL() + "/images/gifts/gift_ceremonias.svg";
        break;
      case defaultConst.eventType.Fiesta_Infantil:
        eventIconImageURL =
          commonUtil.getAssetURL() + "/images/gifts/gift_cumple.svg";
        break;
      case defaultConst.eventType.Cumpleanos:
        eventIconImageURL =
          commonUtil.getAssetURL() + "/images/gifts/gift_cumpleanos.svg";
        break;
      case defaultConst.eventType.Fiesta_Reunion:
        eventIconImageURL =
          commonUtil.getAssetURL() + "/images/gifts/gift_todotipo.svg";
        break;
      default:
        break;
    }
    const eventIconImageAttr = {
      id: "img1",
      alt: "Liverpool",
      src: eventIconImageURL,
      altImg: commonUtil.getAssetURL() + "/images/gifts/gift_bebes.svg",
      className: "eventMessageImage",
    };

    let catalogName = commonUtil.getLabel(
      lables.EventAdminPage,
      "adminpage.summary.catalog.lp.label"
    );
    if (commonUtil.getBrand() === defaultConst.constBrand.PB) {
      catalogName = commonUtil.getLabel(
        lables.EventAdminPage,
        "adminpage.summary.catalog.pb.label"
      );
    } else if (commonUtil.getBrand() === defaultConst.constBrand.PBK) {
      catalogName = commonUtil.getLabel(
        lables.EventAdminPage,
        "adminpage.summary.catalog.pbk.label"
      );
    } else if (commonUtil.getBrand() === defaultConst.constBrand.GAP) {
      catalogName = commonUtil.getLabel(
        lables.EventAdminPage,
        "adminpage.summary.catalog.gap.label"
      );
    } else if (commonUtil.getBrand() === defaultConst.constBrand.WLM) {
      catalogName = commonUtil.getLabel(
        lables.EventAdminPage,
        "adminpage.summary.catalog.wlm.label"
      );
    } else if (commonUtil.getBrand() === defaultConst.constBrand.WS) {
      catalogName = commonUtil.getLabel(lables.EventAdminPage, 'adminpage.summary.cataog.ws.label');
    } else if (commonUtil.getBrand() === defaultConst.constBrand.TRU) {
      catalogName = commonUtil.getLabel(lables.EventAdminPage, 'adminpage.summary.catalog.tru.label');
    }
    const CatálogoLiverpool = {
      displayName: catalogName,
      children: "Catálogo Liverpool ",
      areaLabel: "abc",
      href: _url,
      id: "lnkLPWeb",
      class: "linkClass",
      anotherDomain: true,
      onClickHandler: this.catalogoHandler,
    };
    const Listaspredeterminadas = {
      displayName: commonUtil.getLabel(
        lables.EventAdminPage,
        "adminpage.summary.default.lists.label"
      ),
      children: "Listas predeterminadas",
      areaLabel: "abc",
      route: this.predeterminedRoute,
      class: "linkClass",
      anotherDomain: false,
      onClickHandler: this.predefinedHandler,
    };
    const Sugerenciaderegalos = {
      displayName: commonUtil.getLabel(
        lables.EventAdminPage,
        "adminpage.summary.gift.suggetion.label"
      ),
      children: "Sugerencia de regalos",
      areaLabel: "abc",
      href:
        this.eventSummaryInfo && this.eventSummaryInfo.eventInfo
          ? this.eventSummaryInfo.eventInfo.suggestionLink
          : "",
      class: "linkClass",
      anotherDomain: true,
      onClickHandler: this.suggestionHandler,
    };

    linkJSON.push(CatálogoLiverpool);
    if (
      commonUtil.getBrand() === defaultConst.constBrand.LP &&
      this.eventSummaryInfo &&
      this.eventSummaryInfo.eventInfo &&
      this.eventSummaryInfo.eventInfo.predeterminedListIdExists &&
      this.eventSummaryInfo.eventInfo.predeterminedListIdExists === true
    ) {
      linkJSON.push(Listaspredeterminadas);
    }
    if (
      this.eventSummaryInfo &&
      this.eventSummaryInfo.eventInfo &&
      this.eventSummaryInfo.eventInfo.suggestionLink !== ""
    ) {
      linkJSON.push(Sugerenciaderegalos);
    }

    const buttonAttr = {
      type: "button",
      value: lables
        ? commonUtil.getLabel(
            lables.EventAdminPage,
            "adminpage.summary.eventaccontpage.hyperlink.message"
          )
        : "Estado de cuenta",
      autoFocus: false,
      style:
        this.eventStatusInfo &&
        this.props.compareEventStatus(
          this.eventStatusInfo,
          defaultConst.eventStatus.ADMINISTRATIVE_PROCESS
        )
          ? "btnSecondarySpecial size-Full btnSecondarySpecialDisable"
          : "btnSecondarySpecial size-Full",
      onClickHandler: this.accountStatusRoute,
      disabled:
        this.eventStatusInfo &&
        this.props.compareEventStatus(
          this.eventStatusInfo,
          defaultConst.eventStatus.ADMINISTRATIVE_PROCESS
        )
          ? "disabled"
          : "",
    };
    const agregarRegaloaMiMesaButton = {
      id: "dLabel",
      type: "button",
      value: commonUtil.getLabel(
        lables.EventAdminPage,
        "adminpage.summary.addagift.dropdown.message"
      ),
      autoFocus: false,
      style:
        this.eventStatusInfo &&
        this.props.compareEventStatus(
          this.eventStatusInfo,
          defaultConst.eventStatus.SUSPENDED
        )
          ? "btnPrimarySpecial size-Full btnPrimarySpecialDisable"
          : "btnPrimarySpecial size-Full",
      onClickHandler: this.showAgregarDropdown,
      disabled:
        this.eventStatusInfo &&
        this.props.compareEventStatus(
          this.eventStatusInfo,
          defaultConst.eventStatus.SUSPENDED
        )
          ? "disabled"
          : "",
      iconClass: "icon-flecha_lightsvg_derecha",
    };
    // const imgLinkData2 = {
    //   linkClass: 'imagelink',
    //   imgClass: 'img-responsive',
    //   label: '',
    //   src: commonUtil.getAssetURL() + '/images/admin/editAdminIcon.png',
    //   alt: 'Edit',
    //   href: commonUtil.getRouteByParameter(applicationRoutes.eventManagement, { pageName: 'DatosDeMiEvento', eventID: this.props.eventId }),
    //   id: 'link',
    // };
    // const _imgsrc = [
    //   {
    //     srcSet: this.eventSummaryInfo.eventInfo && this.eventSummaryInfo.eventInfo.eventProfileImage && this.eventSummaryInfo.eventInfo.eventProfileImage,
    //     className: 'adminImage',
    //   },
    // ];
    const imageAttr = {
      id: "img1",
      alt: "Liverpool",
      src:
        this.eventSummaryInfo &&
        this.eventSummaryInfo.eventInfo &&
        this.eventSummaryInfo.eventInfo.eventProfileImage,
      // altImg: commonUtil.getAssetURL() + '/images/addImageIcon.svg',
      altImg: commonUtil.getAssetURL() + "/images/avatar.svg",
    };

    const linkDatosDeEvento = {
      displayName: "Datos de mi evento",
      route: commonUtil.getRouteByParameter(applicationRoutes.eventManagement, {
        pageName: "DatosDeMiEvento",
        eventID: this.props.eventId,
      }),
    };

    if (!this.eventSummaryInfo) {
      return null;
    }

    if (this.eventSummaryInfo.eventInfo) {
      let newMessage = "";
      let messageFlag = false;
      if (this.eventSummaryInfo.eventInfo.eventCountdownMsg) {
        const fullMsg = this.eventSummaryInfo.eventInfo.eventCountdownMsg;
        if (fullMsg.includes(":")) {
          newMessage = fullMsg.split(":");
          messageFlag = true;
        }
      }

      const datosLink = {
        route: commonUtil.getRouteByParameter(
          applicationRoutes.eventManagement,
          { pageName: "DatosDeMiEvento", eventID: this.props.eventId }
        ),
      };

      return (
        <div className="adminContainer">
          <div className="adminSummary">
            <div className="adminInfo">
              <div className="adminImage">
                <Image imageAttr={imageAttr} />
              </div>
              <div className="adminData">
                <h2>{this.eventSummaryInfo.eventInfo.eventName}</h2>
                <span className="eventDate">
                  {commonUtil.getLabel(
                    lables.EventAdminPage,
                    "adminpage.summary.date.of.event.label"
                  )}
                  : {this.eventSummaryInfo.eventInfo.eventDate}
                </span>
                <span className="eventID">
                  {commonUtil.getLabel(
                    lables.EventAdminPage,
                    "adminpage.summary.event.number.label"
                  )}
                  : {this.eventSummaryInfo.eventInfo.eventId}
                </span>
                {/* <ImageLink imgLinkData={imgLinkData2} /> */}
                <Link rrLink={datosLink}>
                  <label className="icon-datos_de_mi_evento" />
                </Link>
                <Link rrLink={linkDatosDeEvento}>
                  <span>
                    {lables
                      ? commonUtil.getLabel(
                          lables.EventAdminPage,
                          "adminpage.summary.eventdatapage.hyperlink.message"
                        )
                      : ""}
                  </span>
                </Link>
              </div>
            </div>
            <div className="eventBlock">
              {this.eventStatusInfo !== defaultConst.eventStatus.SUSPENDED ? (
                <React.Fragment>
                  {!this.eventSummaryInfo.eventInfo.eventCountdown ? (
                    <div className="daysLeft congratulations">
                      <div>
                        {/* <i className="icon-bandera_boda" /> */}
                        <Image imageAttr={eventIconImageAttr} />
                      </div>
                      {this.eventSummaryInfo.eventInfo.eventCountdownMsg &&
                      messageFlag ? (
                        <React.Fragment>
                          <p className="newMessageIcon"> {newMessage[0]}</p>
                          <p className="eventCongratulationsMessage">
                            {newMessage[1]}
                          </p>
                        </React.Fragment>
                      ) : (
                        <p className="eventCongratulationsMessage">
                          {this.eventSummaryInfo.eventInfo.eventCountdownMsg}
                        </p>
                      )}
                    </div>
                  ) : (
                    <div className="daysLeft congratulations">
                      {/* <div><i className="icon-bandera_boda" /></div> */}
                      <p>
                        <span>
                          {this.eventSummaryInfo.eventInfo.eventCountdown}&nbsp;
                        </span>
                        {lables
                          ? commonUtil.getLabel(
                              lables.EventAdminPage,
                              "adminpage.summary.daysleft.message"
                            )
                          : ""}
                      </p>
                    </div>
                  )}
                </React.Fragment>
              ) : (
                ""
              )}
              <div className="eventButtons">
                {this.props.compareEventStatus(
                  this.eventStatusInfo,
                  defaultConst.eventStatus.VALIDITY_OFF_ACTIVE
                ) ||
                this.props.compareEventStatus(
                  this.eventStatusInfo,
                  defaultConst.eventStatus.CLOSED
                ) ||
                this.props.compareEventStatus(
                  this.eventStatusInfo,
                  defaultConst.eventStatus.TEMPORARY_CLOSED
                ) ? null : (
                  <div id="dropdown" className="dropdown">
                    <InputButton buttonAttr={agregarRegaloaMiMesaButton} />
                    <ul className="dropdown-menu" aria-labelledby="dLabel">
                      {linkJSON.map((link, id) => (
                        <li key={id + "events"}>
                          {/* {id === 0 || id === 2 || (commonUtil.getBrand() !== defaultConst.constBrand.LP) ? <Link linkJSON={link}> */}
                          {link.anotherDomain ||
                          commonUtil.getBrand() !==
                            defaultConst.constBrand.LP ? (
                            <Link linkJSON={link}>
                              {link.displayName}
                              <i className="icon-flecha_lightsvg_derecha" />
                            </Link>
                          ) : (
                            <Link rrLink={link}>
                              {" "}
                              {link.displayName}{" "}
                              <i className="icon-flecha_lightsvg_derecha" />{" "}
                            </Link>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                <div>
                  <Tagging ref={(tagging) => (this.tagging = tagging)} />
                  <InputButton buttonAttr={buttonAttr} />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return null;
  }
}
const matchDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getEventSummaryInfo,
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  // eventInfo: state.giftList.data,
  eventSummaryInfoHeader:
    state.giftList &&
    state.giftList.data &&
    state.giftList.data.eventSummaryInfo, //  && state.giftList.data.eventSummaryInfo,
  user: state.user.data,
});

export default connect(mapStateToProps, matchDispatchToProps)(GiftListHeader);
